<template>
  <div>
    <div class="fullscreen-modal__content">
      <page>
        <page-title>
          {{ $t('c.mailingOverlay.stepHistory.title') }}
        </page-title>

        <div v-if="mailings && mailings.length > 0">
          <div
            v-if="publishedMailings && publishedMailings.length > 0"
            class="text-center add-padding-y"
          >
            <router-link
              :to="{ name: 'LatestNewsletterPage', params: { folderId: this.$route.params.folderId } }"
              class="button button--outline"
            >
              {{ $t('c.mailingOverlay.stepHistory.showLatestNewsletter') }}
            </router-link>
          </div>

          <list-item
            v-for="mailing in mailings"
            :key="mailing.id"
            :title="mailingTitle(mailing)"
            :title-clickable="true"
            :subline="mailingSubline(mailing)"
            :dropdown-options="dropdownOptions(mailing)"
            @dropdown-select="action => dropdownSelect({mailing, action})"
            @on-click="openMailing(mailing)"
          />
        </div>
        <div v-else>
          <div class="text-center add-padding-y-double">
            {{ $t('c.mailingOverlay.stepHistory.no_entries') }}
          </div>
        </div>

      </page>
    </div>
    <div class="fullscreen-modal__footer">
      <div class="container">
        <div class="row">
          <div class="col-xs-6 col-lg-4 push-lg-2">
            <button-input
              v-t="'c.mailingOverlay.stepHistory.btnNew'"
              @click="nextStep"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import FormMixin from '@/mixins/forms/Form'
import PageMixin from '@/mixins/pages/Page'
import fullDateTime from '@/filters/fullDateTime'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import ListItem from '@/components/ui/ListItem'
import isBlank from 'is-blank'

export default {
  mixins: [FormMixin, PageMixin],
  filters: {
    fullDateTime
  },
  components: {
    FontAwesomeIcon,
    ListItem
  },
  computed: {
    ...mapState({
      mailings: state => state.mailing.entries
    }),
    publishedMailings () {
      return this.mailings.filter(mailing => mailing.status == 'published')
    }
  },
  methods: {
    ...mapActions ({
      openConfirmModal: 'openConfirmModal',
      closeConfirmModal: 'closeConfirmModal',
      fetchMailings: 'mailing/fetchEntries',
      fetchMailing: 'mailing/entry/fetchMailing',
      resetMailing: 'mailing/entry/reset',
      setFolderId: 'mailing/entry/setFolderId',
      loadMailing: 'mailing/entry/loadMailing',
      destroyMailing: 'mailing/entry/destroyMailing',
      nextStep: 'mailing/step/next'
    }),
    mailingTitle (mailing) {
      return isBlank(mailing.title)
        ? 'Newsletter'
        : mailing.title
    },
    mailingSubline (mailing) {
      return mailing.status + ' - ' + this.$options.filters.fullDateTime(mailing.createdAt)
    },
    dropdownOptions (mailing) {
      return mailing.status === 'draft'
        ? [
            { label: 'Bearbeiten', value: 'open', icon: 'edit' },
            { label: 'Löschen', value: 'delete', icon: 'trash' }
          ]
        : [
            { label: 'Anzeigen', value: 'open', icon: 'external-link-alt' },
            { label: 'Löschen', value: 'delete', icon: 'trash' }
          ]
    },
    openMailing (mailing) {
      if (mailing.status === 'draft') {
        this.loadMailing(mailing)
      } else {
          let route = this.$router.resolve({name: 'Newsletter', params: {id: mailing.id}})
          window.open(route.href, '_blank')
      }
    },
    dropdownSelect ({mailing, action}) {
      switch (action) {
        case 'open':
          this.openMailing(mailing)
          break
        case 'delete':
          this.openConfirmModal({
            title: 'Eintrag löschen',
            message: `"${this.mailingTitle(mailing)}" wirklich löschen?`,
            callback: () => {
              this.destroyMailing(mailing.id)
                .then(() => this.fetchMailings(this.$route.params.folderId))
                .then(this.closeConfirmModal)
            }
          })
          break
        default:
          console.log(`action: ${action}`)
      }
    }
  },
  updated () {
    this.resetMailing()
    this.setFolderId(this.$route.params.folderId)
  }
}
</script>

<style lang="sass">
@import '~styles/imports'
</style>




// WEBPACK FOOTER //
// src/components/mailings/steps/History.vue